<button [id]="idVal" type="button" (click)="onClick.emit($event)" class="btn st-button-filter rounded-pill">
  <i class="bi bi-filter"></i>
    {{label}}
</button>
